import React, { Component } from 'react'
import { withTheme } from '@material-ui/core/styles';
import { XAxis, YAxis, Label, ResponsiveContainer, BarChart, Bar } from 'recharts'
import Typography from '@material-ui/core/Typography'
import { inject, observer } from 'mobx-react'


@withTheme
@inject('HomeStore')
@observer
class RevenueChart extends Component {

  componentWillMount() {
    this.props.HomeStore.fetchRevenueChart()
  }

  forceRender = source => {
    const data = source.sort()
    return data
  }

  render() {
    const { theme } = this.props
    const { revenueChart } = this.props.HomeStore

    return (
      <React.Fragment>
        <Typography component="h2" variant="h6" color='textPrimary' gutterBottom>
          Revenue
        </Typography>
        <ResponsiveContainer>
          <BarChart
            data={this.forceRender(revenueChart)}
            margin={{
              top: 16,
              right: 16,
              bottom: 0,
              left: 24,
            }}
          >
            <XAxis dataKey="datetime" stroke={theme.palette.text.secondary} />
            <YAxis stroke={theme.palette.text.secondary}>
              <Label
                angle={270}
                position="left"
                style={{ textAnchor: 'middle', fill: theme.palette.text.primary }}
              >
                Sales ($)
              </Label>
            </YAxis>
            <Bar dataKey='revenue' fill={theme.palette.primary.light} />
          </BarChart>
        </ResponsiveContainer>
      </React.Fragment>
    )
  }
}
export default RevenueChart